import ENVIRONMENT from '@/env';

export default class MediaItem {
  constructor(data) {
    this.alttext = null;
    this.url = null;
    // Initialize data
    if (data) {
      Object.assign(this, {
        alttext: data.AltText,
        url: MediaItem.getUrl(data.Url)
      });
    }
  }

  static getUrl(data) {
    return `${ENVIRONMENT.baseUrl + data}`;
  }
}



// WEBPACK FOOTER //
// src/entities/case/media-items/media-item.js